import React from "react";
import { useTranslation } from "react-i18next";
import ProUpgradeButton from "../ProUpgradeButton";

const ProUpgradeSection = ({ userInfo }) => {
  const { t } = useTranslation();

  return (
    <section className="bg-secondary p-6 rounded-2xl shadow-lg">
      <div className="text-center mb-6">
        <h2 className="text-xl font-semibold text-test mb-2">
          {t("settings.proUpgrade.title")}
        </h2>
        <p className="text-white/80">{t("settings.proUpgrade.description")}</p>
      </div>
      <ProUpgradeButton userInfo={userInfo} />
    </section>
  );
};

export default ProUpgradeSection;
